import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["colorElement", "colorBar", "labelColor"]

  connect() {
    this.applyColors()
    this.applyProgressBars()
    this.applyColorBars()
  }

  applyColors() {
    // Handle elements with data-color attribute
    this.element.querySelectorAll('[data-color]').forEach(element => {
      const color = element.dataset.color
      if (color && this.isValidColor(color)) {
        element.style.backgroundColor = color
      }
    })

    // Handle color element targets
    this.colorElementTargets.forEach(element => {
      const color = element.dataset.color
      if (color && this.isValidColor(color)) {
        element.style.backgroundColor = color
      }
    })

    // Handle label color targets
    this.labelColorTargets.forEach(element => {
      const color = element.dataset.color
      if (color && this.isValidColor(color)) {
        element.style.backgroundColor = color
      }
    })
  }

  applyProgressBars() {
    // Handle progress bars with data-progress attribute
    this.element.querySelectorAll('[data-progress]').forEach(element => {
      const progress = element.dataset.progress
      if (progress !== undefined && progress !== null) {
        const progressValue = Math.max(0, Math.min(100, parseInt(progress) || 0))
        element.style.width = `${progressValue}%`
      }
    })
  }

  applyColorBars() {
    // Handle color bar targets (top accent bars)
    this.colorBarTargets.forEach(element => {
      const color = element.dataset.color
      if (color && this.isValidColor(color)) {
        element.style.backgroundColor = color
      }
    })
  }

  isValidColor(color) {
    // Validate hex colors and basic color names
    return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color) || 
           /^(red|blue|green|yellow|purple|orange|pink|indigo|cyan|teal|emerald)$/.test(color)
  }

  hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null
  }
}
